import { render, staticRenderFns } from "./PageTwo.vue?vue&type=template&id=664f34fe&scoped=true"
import script from "./PageTwo.vue?vue&type=script&lang=js"
export * from "./PageTwo.vue?vue&type=script&lang=js"
import style0 from "./PageTwo.vue?vue&type=style&index=0&id=664f34fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664f34fe",
  null
  
)

export default component.exports